import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyLegLoadsManageReadingsPage } from './daily-leg-load-manage-readings';
import { TextMaskModule } from 'angular2-text-mask';
import { DirectivesModule } from '../../../directives/directives.module';
import { BodyModule, GridModule } from '@progress/kendo-angular-grid';
import {
  DailyLegLoadsAddFrequencyComponent
} from './components/daily-leg-load-add-frequency/daily-leg-loads-add-frequency';
import { TabStripModule } from '@progress/kendo-angular-layout';
import {
  DailyLegLoadsFrequencyChangeGridComponent
} from './components/daily-leg-load-frequency-change-grid/daily-leg-loads-frequency-change-grid';
import {
  DailyLegLoadsAddStandaloneReadingComponent
} from './components/daily-leg-load-add-standalone-reading/daily-leg-loads-add-standalone-reading';
import {
  DailyLegLoadStandaloneReadingGridComponent
} from './components/daily-leg-load-standalone-reading-grid/daily-leg-load-standalone-reading-grid';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    declarations: [
        DailyLegLoadsManageReadingsPage,
        DailyLegLoadsAddFrequencyComponent,
        DailyLegLoadsAddStandaloneReadingComponent,
        DailyLegLoadsFrequencyChangeGridComponent,
        DailyLegLoadStandaloneReadingGridComponent
    ],
    imports: [
        DirectivesModule,
        IonicPageModule.forChild(DailyLegLoadsManageReadingsPage),
        TextMaskModule,
        GridModule,
        BodyModule,
        SharedModule,
        TabStripModule,
        SharedModule,
    ],
    exports: [
        DailyLegLoadStandaloneReadingGridComponent
    ],
    entryComponents: [
        DailyLegLoadsAddFrequencyComponent,
        DailyLegLoadsAddStandaloneReadingComponent
    ]
})
export class DailyLegLoadManageRecordingsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-manage-readings/daily-leg-load-manage-readings.module.ts